exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".erro-404-body[data-v-7e8dd037]{width:100%;height:100vh;background-color:#8b0000;position:absolute;margin:0;padding:0}.erro-message[data-v-7e8dd037]{font-size:35px}.erro-icon[data-v-7e8dd037],.erro-message[data-v-7e8dd037]{color:#fff;text-align:center}.erro-icon[data-v-7e8dd037]{font-size:230px}", ""]);

// exports
